import { Docking } from '../../../types';
import { isNullOrUndefined } from '../../../utils/utils';

export function getIsOperatingCargo(docking?: Docking) {
  if (!docking) {
    return false;
  }
  const isOperatingCargo =
    Object.values(docking).some((value) => {
      if (isNullOrUndefined(value)) {
        return false;
      }
      return true;
    }) || (docking.operations?.length ?? 0) > 0;

  return isOperatingCargo;
}
